/**
 * A empresa que a pendência do documento mandou abrir (`/risk-applications?companyId=7`).
 *
 * Sem ler o parâmetro, quem clica em "Vincular riscos" no bloco de pendências chega numa
 * tela em branco e precisa adivinhar de qual empresa era o documento que estava emitindo.
 *
 * Mora fora da página porque quem exporta função ao lado de um componente quebra o
 * fast-refresh do Vite (`react-refresh/only-export-components`).
 */
export function empresaDaBusca(busca: string): number | null {
  const valor = Number(new URLSearchParams(busca).get('companyId'));
  return Number.isInteger(valor) && valor > 0 ? valor : null;
}
